import { Change, Element } from '@ritabygglov/core';
import { createUpdateChange } from '../services/Actions';
import { Command } from './Command';

export class UpdateCommand implements Command {
  constructor(
    private elementUpdates: Element[],
    private originElements: Element[] = [],
    private userId: string,
    public isEphemeral: boolean = false
  ) {}

  execute(): Change[] {
    return this.elementUpdates.map((element) =>
      createUpdateChange(element, this.isEphemeral, this.userId)
    );
  }

  undo(): Change[] {
    return this.originElements.map((element) =>
      createUpdateChange(element, this.isEphemeral, this.userId)
    );
  }
}
